import React from 'react'
import Select from 'react-select'

import TextInput from '../../common/components/TextInput'
import Header from '../../common/components/Header'

import { ESF } from '../constants'

import IncidentSelector from './IncidentSelector'

const customSelectStyles = {
  container: (provided) => ({ ...provided, minWidth: 250 }),
  option: (provided) => ({ ...provided, color: '#000' }),
}

const PostFilter = ({
  queryString,
  setQueryString,
  incidentId,
  setIncidentId,
  setESF,
}) => {
  return (
    <div style={{ padding: '1em' }}>
      <Header>Report Filters</Header>
      <IncidentSelector incidentId={incidentId} setIncidentId={setIncidentId} />
      <TextInput
        value={queryString}
        onChange={setQueryString}
        placeholder={'Search Reports'}
        label={'Search Reports'}
      />
      <h4>Filter by ESF</h4>
      <Select
        options={ESF}
        styles={customSelectStyles}
        onChange={setESF}
        isClearable
      />
    </div>
  )
}

export default PostFilter
